import { util } from 'pevueglobal'
import Vue from 'vue'
// getters
export const graphdata = graphState => state => state[graphState]
// export const ReportState = graphState => state => (graphID) => state[graphState].filter(graph => { graph.graphID === graphID }).reportStatus
// export const GraphByID = graphState => state => (graphID) => state[graphState].filter(graph => { graph.graphID === graphID })

// actions
export const getGraphUrl = reportstatusMutationName => async ({ commit }, graphUrlInput) => {
  let isIpadOS = (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
  // let tabwindow
  let graphID = graphUrlInput.graphGetUrlinputApi.graphIDForUrl
  commit(reportstatusMutationName, { tblRequestReportState: 1, graphID: graphID }) // state meteen op 1 zetten. rapport word gemaakt
  const graphUrl = await util.getDataApi('allroles/PEapi_GraphControl_GetUrl', graphUrlInput.graphGetUrlinputApi)
  if (graphUrl.ds.data0[0].url === 'report') {
    commit(reportstatusMutationName, { tblRequestReportState: 1, graphID: graphID }) // report status op 1, PEapi_GraphControl_GetUrl trapt het rapport af
    await checkapiForReportStatus(commit, graphUrl.ds.data0[0].reportGuid, graphID, reportstatusMutationName) // loop die checked of reportserver klaar is, de functie doet zelf de setReportStatus commit
  } else {
    if (graphUrlInput.graphShowInPopup === true && !isIpadOS) {
      window.open(graphUrl.ds.data0[0].url + '&vue=true')
    } else {
      window.location = graphUrl.ds.data0[0].url + '&vue=true'
    }
    commit(reportstatusMutationName, { tblRequestReportState: 0, graphID: graphID })
  }
}

// mutations

// zet van alle graphs de status op 0, begin status, b.v. voor als je van pagina wisselt en alles dichtgeklapt moet worden
export const resetreportstatus = graphState => state => {
  state[graphState].forEach(graph => {
    graph.reportStatus = 0
  })
}

// word intern gebruikt om de status van rapport op te vragen tijdens aanvraag
export const setReportStatus = graphState => (state, data) => {
  state[graphState].filter(graph => graph.graphID === data.graphID)[0].reportStatus = data
}

export const setGraphdata = graphState => (state, data) => {
  state[graphState] = data.ds.data0
  state[graphState].forEach(graph => {
    Vue.set(graph, 'reportStatus', { tblRequestReportState: 0, graphID: graph.graphID })
  })
}

// helper functions

// check status report
const checkapiForReportStatus = async (commit, reportguidInput, graphID, reportstatusMutationName) => {
  const RS = await util.getDataApi('allroles/PEapi_GraphControl_CheckReportStatus', { reportguid: reportguidInput })
  if (RS.ds.data0.tblRequestReportState < 2) {
    setTimeout(function() {
      checkapiForReportStatus(commit, reportguidInput, graphID, reportstatusMutationName)
    }, 1000)
  }
  if (RS) {
    RS.ds.data0.graphID = graphID
    commit(reportstatusMutationName, RS.ds.data0)
  } else {
    commit(reportstatusMutationName, { tblRequestReportState: 1, graphID: graphID })
  }
}
